// Port seam for the OS hotkey registration (SCR-7069): the Tauri
// `dictation_set_hotkey` IPC lives app-side, so
// `src/utils/dictation-hotkey-wiring.ts` injects it at bootstrap. Fail-loud:
// a missing port would silently skip OS-level registration on save.

export interface DictationHotkeyPorts {
  /** Forward the chord to the OS hotkey layer; the app-side impl no-ops outside Tauri. */
  setDictationHotkey: (modifiers: string[], key: string | null) => Promise<void>;
}

let ports: DictationHotkeyPorts | null = null;

export const configureDictationHotkeyPorts = (next: DictationHotkeyPorts): void => {
  ports = next;
};

export const getDictationHotkeyPorts = (): DictationHotkeyPorts => {
  if (!ports) {
    throw new Error(
      '[dictation/ui/onboarding/hotkey] ports not configured — the app must load ' +
        "'@/utils/dictation-hotkey-wiring' at bootstrap; tests must call " +
        'configureDictationHotkeyPorts() with a double first.'
    );
  }
  return ports;
};

export const resetDictationHotkeyPortsForTests = (): void => {
  ports = null;
};
